<template>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose" :append-to-body="true">
    <el-form size="small" :model="form" ref="form" label-width="100px" class="demo-ruleForm">
      <el-form-item label="所属目录" prop="selected">
        <wlTreeSelect leaf width="240" :leaf="true":checkbox="false" :data="categoryModel.catList" @change="hindleChanged" v-model="selected">
        </wlTreeSelect>
      </el-form-item>
      <el-form-item label="专栏名称" prop="groupName" :rules="[{ required: true, message: '名称不能为空'}]">
        <el-input type="age" v-model="form.groupName" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="专栏价格" prop="price":rules="[{ required: true, message: '专栏价格不能为空'}]">
        <el-input type="number" v-model="form.price" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="划线价格" prop="linePrice" :rules="[{ required: true, message: '划线价格不能为空'}]">
        <el-input type="age" v-model="form.linePrice" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="专栏介绍" prop="remark">
        <el-input type="textarea" v-model="form.remark" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="handleClose">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm()">提交</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>
</template>

<script>
import FileApi from '@/api/file.js';
import PorductApi from '@/api/product.js';

export default {
  data(){
    return {
      value: [], // 选中值
      selectValue:[],
      selected: [  ],// 树下拉框选中数据
      categoryModel: {
        categoryType: -1, // 与第一个选项的 :value 匹配

        catList: [],
        model: {}
      },
      /*是否显示*/
      dialogVisible:true,
      title: '添加分类',
      /*from表单模型*/
      form:{
        categoryId:0,// 关联类型id
        categoryType:2,// 关联类型
        groupName:'',
        groupId: 0,
        isNeedPay:1,
        price:0,
        linePrice:0,
        remark:''
      }
    }
  },
  props:['category', 'fileType'],
  created() {
    if(this.category != null){
      this.form.categoryId=this.category.categoryId;
      this.form.categoryName=this.category.categoryName;
      this.form.groupName = this.category.groupName;
      this.form.groupId = this.category.groupId;
      this.form.price = this.category.price;
      this.form.linePrice = this.category.linePrice;
      this.form.remark = this.category.remark;

      this.title = '编辑专栏';
    }else{
      this.form.groupName = '';
      this.form.groupId = 0;
      this.title = '添加分类';
    }
    this.getCategoryData();
    if(this.form.categoryId!=null&&this.form.categoryId!=0) {

      this.selected = [{name: this.form.categoryName, categoryId: this.form.categoryId}];
    }
  },
  methods:{

    /*添加图片类别*/
    addCategory: function() {
      let self = this;
      if(self.selected.length==0){
        alert("请选择所属目录");
        return;
      }
      self.form.categoryId = self.selected[0].categoryId;
      FileApi.addCategory({
        categoryId:self.form.categoryId,
        categoryType:self.form.categoryType,
        groupName: self.form.groupName,
        price: self.form.price,
        linePrice: self.form.linePrice,
        isNeedPay: self.form.isNeedPay,
        remark :self.form.remark,

        groupType: self.fileType
      },).then(data => {
          self.$message({
            message: '添加成功',
            type: 'success'
          });
          self.handleClose({status:'success'});
        })
        .catch(error => {
          self.$message.error('添加失败');
        });
    },
    /*获取分类列表*/
    getCategoryData() {

      let self = this;
      self.loading = true;

      PorductApi.catList({type: 2
      }, true)
              .then(res => {
                // let type = [{
                //   categoryId: 1,
                //   name: '全部'
                // }];
                self.loading = false;
                self.tableData = res.data;
                self.categoryModel.catList = self.tableData;

              })
              .catch(error => {
                self.loading = false;
              });

    },
    /*修改图片类别*/
    editCategory: function() {
      let self = this;
      if(self.selected.length==0){
        alert("请选择对应分类");
        return;
      }
      let param = {
        categoryType:self.form.categoryType,
        categoryId:self.selected[0].categoryId,
        groupName: this.form.groupName,
        groupId: this.form.groupId,
        price: self.form.price,
        linePrice: self.form.linePrice,
        isNeedPay: self.form.isNeedPay,
        remark: self.form.remark,

      };
      FileApi.editCategory(param).then(data => {
          self.$message({
            message: '修改成功',
            type: 'success'
          });
          self.handleClose({status:'success'});
        })
        .catch(error => {
          self.$message.error('修改失败');
        });
    },

    /*提交*/
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if(this.category && this.category.groupId != null){
            this.editCategory();
          }else{
            this.addCategory();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },


    /*关闭弹窗*/
    handleClose(param){
      this.dialogVisible=false;
      this.$emit('closeCategory',param);
    }
  }

}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/file/part/AddCategory2.vue